(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-context/assets/javascripts/competition-provider.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-context/assets/javascripts/competition-provider.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const CompetitionContext = svs.components.marketplaceCompetition.competitionContext.CompetitionContext;
const CompetitionProvider = _ref => {
  let children = _ref.children,
    competitionId = _ref.competitionId,
    useDraws = _ref.useDraws;
  const context = useMemo(() => ({
    competitionId,
    useDraws
  }), [competitionId, useDraws]);
  return React.createElement(CompetitionContext.Provider, {
    value: context
  }, children);
};
setGlobal('svs.components.marketplaceCompetition.competitionContext.CompetitionProvider', CompetitionProvider);

 })(window);